import { Alert } from 'react-bootstrap';

type Props = {
  // Why the controls under it are off; nothing is rendered when they are not.
  reason: string | null;
  className?: string;
};

/**
 * The reason a group of controls is off, shown where those controls are: the Send panel's "The send is locked"
 * pattern. The page-level banner says it once at the top; this says it again next to what it locks.
 */
export function PushLockNote({ reason, className = 'py-1 px-2 small' }: Props): JSX.Element | null {
  if (!reason) {
    return null;
  }
  return (
    <Alert variant="secondary" className={className}>
      <i className="fas fa-lock mr-1" aria-hidden="true" />
      {reason}
    </Alert>
  );
}
